import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import CompanyRegistration from './CompanyRegistration'

const CompanyOnboarding = () => {
  const { user } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    // Check if user is authenticated and has selected company role
    if (!user) {
      navigate('/auth/login')
      return
    }
    
    // If user hasn't selected company role, redirect to role selection
    if (user.role !== 'company' && sessionStorage.getItem('selectedRole') !== 'company') {
      navigate('/auth/role-selection')
      return
    }
  }, [user, navigate])

  // If user is authenticated and has company role, show the company registration
  return <CompanyRegistration />
}

export default CompanyOnboarding